<!-- 区間 -->
<input
  id="criteo_segment_code"
  type="hidden"
  name="criteoSegmentCode"
  value="{{ criteoAlignmentInfo.criteoSegmentCode }}"
/>
<!-- 端末種別 -->
<input
  id="criteo_device_type"
  type="hidden"
  name="criteoDeviceType"
  value="{{ criteoAlignmentInfo.criteoDeviceType }}"
/>
<!-- 往路出発日 -->
<input
  id="criteo_departure_date"
  type="hidden"
  name="criteoDepartureDate"
  value="{{ criteoAlignmentInfo.criteoDepartureDate }}"
/>
<!-- 復路出発日 -->
<input
  id="criteo_arrival_date"
  type="hidden"
  name="criteoArrivalDate"
  value="{{ criteoAlignmentInfo.criteoArrivalDate }}"
/>
<!-- CONNECTION_KIND -->
<input
  id="criteo_connection_kind"
  type="hidden"
  name="criteoConnectionKind"
  value="{{ criteoAlignmentInfo.criteoConnectionKind }}"
/>
<!-- 言語コード -->
<input
  id="criteo_language_code"
  type="hidden"
  name="criteoLanguageCode"
  value="{{ criteoAlignmentInfo.criteoLanguageCode }}"
/>
<!-- 片道旅程/往復旅程フラグ -->
<input
  id="criteo_search_mode"
  type="hidden"
  name="criteoSearchMode"
  value="{{ criteoAlignmentInfo.criteoSearchMode }}"
/>
<!-- 大人人数 -->
<input
  id="criteo_adult_count"
  type="hidden"
  name="criteoAdultCount"
  value="{{ criteoAlignmentInfo.criteoAdultCount }}"
/>
<!-- 小児人数 -->
<input
  id="criteo_child_count"
  type="hidden"
  name="criteoChildCount"
  value="{{ criteoAlignmentInfo.criteoChildCount }}"
/>
<!-- 幼児人数 -->
<input
  id="criteo_infant_count"
  type="hidden"
  name="criteoInfantCount"
  value="{{ criteoAlignmentInfo.criteoInfantCount }}"
/>
<!-- 運賃種別 -->
<input
  id="criteo_boarding_class"
  type="hidden"
  name="criteoBoardingClass"
  value="{{ criteoAlignmentInfo.criteoBoardingClass }}"
/>
<!-- 運賃オプション -->
<input
  id="criteo_boarding_class_option"
  type="hidden"
  name="criteoBoardingClassOption"
  value="{{ criteoAlignmentInfo.criteoBoardingClassOption }}"
/>
<!-- 運賃総額 -->
<input
  id="criteo_total_amount"
  type="hidden"
  name="criteoTotalAmount"
  value="{{ criteoAlignmentInfo.criteoTotalAmount }}"
/>
<!-- トランザクションID -->
<input
  id="criteo_transaction_id"
  type="hidden"
  name="criteoTransactionId"
  value="{{ criteoAlignmentInfo.criteoTransactionId }}"
/>
<!-- 顧客区分 -->
<input
  id="criteo_customer_type"
  type="hidden"
  name="criteoCustomerType"
  value="{{ criteoAlignmentInfo.criteoCustomerType }}"
/>
